import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const ApprovePayout = props => <PayoutWorkspace mode="approve" {...props} />;
export default ApprovePayout;
